import React, { useEffect, useState } from "react";
import "../FormTemplates.css";
import payroll_bg from "./Payroll_direct_deposit.png";
import OverlayField from "../OverlayField";

export default function PayrollDirectDepositTemplate({ data, isDownload = false }) {
  const downloadStyles = { fontSize: '14px' };
  const previewStyles = { fontSize: '9px' };

  const [bgLoaded, setBgLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = payroll_bg;
    img.onload = () => setBgLoaded(true);
  }, []);

  return (
    <div className={isDownload ? "w4-wrapper-download" : "w4-wrapper-preview"} style={isDownload ? downloadStyles : previewStyles}>
      {bgLoaded && (<>
        <img src={payroll_bg} alt="W4 Form" className="w4-bg" />

        {/* Filled details -- widths are the gap to whatever sits next on the
            same row, or the page's right margin -- see OverlayField.js. */}
        <OverlayField isDownload={isDownload} d={{ top: "110px", left: "285px", width: 319 }} p={{ top: "48px", left: "130px", width: 146 }}>
          {new Date().toLocaleDateString()}
        </OverlayField>
        <OverlayField isDownload={isDownload} d={{ top: "110px", left: "614px", width: 126 }} p={{ top: "48px", left: "280px", width: 51 }}>
          {data?.mobile}
        </OverlayField>
        <OverlayField isDownload={isDownload} d={{ top: "178px", left: "285px", width: 455 }} p={{ top: "78px", left: "130px", width: 201 }}>
          {data?.firstName || ''} {data?.middleName || ''} {data?.lastName || ''}
        </OverlayField>
        {(data?.bankAccounts || []).map((account, index) => (
          <div key={index}>
            <OverlayField isDownload={isDownload} d={{ top: `${521 + index * 24}px`, left: "70px", width: 150 }} p={{ top: `${233.5 + index * 10.5}px`, left: "32px", width: 69 }}>
              {account.bankName}
            </OverlayField>
            <OverlayField isDownload={isDownload} d={{ top: `${521 + index * 24}px`, left: "230px", width: 50 }} p={{ top: `${233.5 + index * 10.5}px`, left: "105px", width: 21 }}>
              {account.typeCode}
            </OverlayField>
            <OverlayField isDownload={isDownload} d={{ top: `${521 + index * 24}px`, left: "290px", width: 133 }} p={{ top: `${233.5 + index * 10.5}px`, left: "130px", width: 62 }}>
              {account.routingNumber}
            </OverlayField>
            <OverlayField isDownload={isDownload} d={{ top: `${521 + index * 24}px`, left: "433px", width: 177 }} p={{ top: `${233.5 + index * 10.5}px`, left: "196px", width: 80 }}>
              {account.accountNumber}
            </OverlayField>
            <OverlayField isDownload={isDownload} d={{ top: `${521 + index * 24}px`, left: "620px", width: 120 }} p={{ top: `${233.5 + index * 10.5}px`, left: "280px", width: 51 }}>
              {account.amount}
            </OverlayField>
          </div>
        ))}
        {data.signatureBase64 && <div className="overlay" style={isDownload ? { top: "745px", left: "285px" } : { top: "335px", left: "130px" }}>
          <img
            src={`${data.signatureBase64}`}
            alt="signature"
            style={isDownload ? { maxHeight: 50, maxWidth: 150 } : { maxHeight: 22, maxWidth: 70 }}
          />
        </div>}
      </>)}
    </div>
  );
}
